import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '../URL/api-url';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  loginEndpoint = '/auth/signin';
  forgotPasswordEndpoint = '/auth/forgotPassword';
  activationCodeEndpoint = '/auth/userActivation/';
  handleCheckUserLoggedInFirstTime = '/check-first-time/';
  handleGetCustomerLogo = '/customer-logo?username=';
  handleGetClientLogos = '/get-client-logos';
  headers = new HttpHeaders();
  getloginEndpoint='/student/logo'

  constructor(private http:HttpClient) { }

  login(data:any) {
    this.headers = this.headers.set('Content-Type', 'application/json').set('Referer', 'https://testausu.groupbenefitz.aitestpro.com/');
    return this.http.post(api.url+this.loginEndpoint, data, {headers: {
      'Content-Type': 'application/json',
      'Referer': 'https://testausu.groupbenefitz.aitestpro.com/'
    }});
  }

  forgotPassword(data:any) {
    this.headers = this.headers.set('Content-Type', 'application/json');
    return this.http.post(api.url+this.forgotPasswordEndpoint, data, {'headers':this.headers});
  }




  checkUserLoggedInForFirstTime(email:any) {
    return this.http.get(api.url+this.handleCheckUserLoggedInFirstTime + email);
  }

  getCustomerLogo(username:any) {
    return this.http.get(api.url+this.handleGetCustomerLogo + username);
  }


  getClientLogos() {
    return this.http.get(api.url+this.handleGetClientLogos);
  }

}
